import {
  arcadeLayout,
  ARCADE_VIEW,
  SYMBOL_BY_CODE,
  perioSummary,
  shapePath,
  shapeCusps,
  arcadeOutward,
} from "@/data/dentalCases";

const ACCENT = "#0d9488";

export function ToothArcade({ species, chart, perioChart, selectedTooth, onTooth }) {
  const layout = arcadeLayout(species);
  const { w, h, midX } = ARCADE_VIEW;
  return (
    <svg
      viewBox={`0 0 ${w} ${h}`}
      className="w-full max-w-[560px] mx-auto block"
      style={{ minWidth: 360 }}
      data-testid="arcade-chart"
    >
      {/* palate / jaw guide lines + midline */}
      <line x1={midX} y1="70" x2={midX} y2={h - 70} stroke="#e2e8f0" strokeWidth="1.5" />
      <text x={midX - 150} y={526} textAnchor="middle" fontSize="15" fontWeight="700" fill="#cbd5e1">Right</text>
      <text x={midX + 150} y={526} textAnchor="middle" fontSize="15" fontWeight="700" fill="#cbd5e1">Left</text>

      {layout.map((tt) => {
        const codes = chart[tt.id] || [];
        const primary = codes.length ? SYMBOL_BY_CODE[codes[0]].color : null;
        const selected = selectedTooth === tt.id;
        const ps = perioSummary(perioChart[tt.id]);
        const [ox, oy] = arcadeOutward(tt);
        const nd = tt.L * 0.5 + 16;
        const fill = primary ? `${primary}3a` : "#eef2f6";
        const stroke = selected ? ACCENT : primary || "#1e293b";
        const halo = Math.max(tt.W, tt.L) * 0.62;
        return (
          <g key={tt.id} data-testid={`arcade-tooth-${tt.id}-btn`} onClick={() => onTooth(tt.id)} style={{ cursor: "pointer" }}>
            {selected && <circle cx={tt.x} cy={tt.y} r={halo} fill={`${ACCENT}12`} stroke={ACCENT} strokeWidth="2" strokeDasharray="5 3" />}
            <g transform={`translate(${tt.x},${tt.y}) rotate(${tt.rot})`}>
              <path d={shapePath(tt.shape, tt.W, tt.L)} fill={fill} stroke={stroke} strokeWidth={selected ? 3 : 1.8} strokeLinejoin="round" />
              {shapeCusps(tt.shape, tt.W, tt.L).map((c) => (
                <line key={`${tt.id}-cusp-${c.join("-")}`} x1={c[0]} y1={c[1]} x2={c[2]} y2={c[3]} stroke={primary || "#94a3b8"} strokeWidth="1" strokeLinecap="round" opacity="0.65" />
              ))}
            </g>
            {/* Triadan number, outside the arch */}
            <text x={tt.x + ox * nd} y={tt.y + oy * nd + 4} textAnchor="middle" fontSize="13" fontWeight="700" fill="#475569" style={{ pointerEvents: "none" }}>
              {tt.id}
            </text>
            {/* charted symbol codes, on the tooth */}
            {codes.length > 0 && (
              <text x={tt.x} y={tt.y + 4} textAnchor="middle" fontSize="11.5" fontWeight="800" fill={primary} style={{ pointerEvents: "none" }}>
                {codes.join("·")}
              </text>
            )}
            {/* periodontal reading, inside the arch */}
            {ps && (
              <text x={tt.x - ox * (tt.L * 0.5 + 10)} y={tt.y - oy * (tt.L * 0.5 + 10) + 3} textAnchor="middle" fontSize="10.5" fontWeight="700" fill="#b45309" style={{ pointerEvents: "none" }}>
                {ps}
              </text>
            )}
            <circle cx={tt.x} cy={tt.y} r={halo + 4} fill="transparent" />
          </g>
        );
      })}
    </svg>
  );
}
